module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9232/js/img/SalesHub_Icon.svg"